// extracted by mini-css-extract-plugin
module.exports = {"bannerHome":"SalesBanner_bannerHome__34yR7","bannerCategory":"SalesBanner_bannerCategory__2Hgw8"};